import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { BreadcrumbComponent } from '../../../../shared/ui/breadcrumb/breadcrumb.component';
import type { BlogPost } from '../../../../shared/models/blog.model';
import { BlogDatePipe, BlogReadTimePipe } from '../../pipes/blog-format.pipes';
import { blogArticleBreadcrumbs } from '../../utils/blog-seo.util';

@Component({
  selector: 'app-article-header',
  imports: [BreadcrumbComponent, RouterLink, BlogDatePipe, BlogReadTimePipe],
  templateUrl: './article-header.component.html',
  styleUrl: './article-header.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'block' },
})
export class ArticleHeaderComponent {
  post = input.required<BlogPost>();

  /** Inicio › Blog › {juego} › {título} (B67); las mismas que el JSON-LD. */
  protected readonly breadcrumbs = computed(() => blogArticleBreadcrumbs(this.post()));
}
